import { render, staticRenderFns } from "./SelectedItemsToolbar.vue?vue&type=template&id=2836dd57&scoped=true&"
import script from "./SelectedItemsToolbar.vue?vue&type=script&lang=js&"
export * from "./SelectedItemsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./SelectedItemsToolbar.vue?vue&type=style&index=0&id=2836dd57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836dd57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VExpandTransition,VIcon})
